module.exports = __webpack_public_path__ + "static/media/makerworld.39647790.svg";